export default __webpack_public_path__ + "static/media/image1.e689b785.png";